const postPasswordCookies = document.cookie
	.split(';')
	.map((cookie) => cookie.trim())
	.filter((cookie) => cookie.startsWith('wp-postpass'));

const passwordLogout = () => {
	if (postPasswordCookies.length > 0) {
		const logoutButton = document.createElement('button');
		const logoutButtonText = document.createTextNode(
			'Logout from Password Protected Content'
		);

		logoutButton.classList.add(
			'post-password-logout-button',
			'c-btn',
			'c-btn-primary'
		);

		logoutButton.appendChild(logoutButtonText);
		document.body.appendChild(logoutButton);

		logoutButton.addEventListener('click', logout);
	}
};

const logout = (e) => {
	e.preventDefault();

	if (postPasswordCookies.length > 0) {
		postPasswordCookies.forEach((cookie) => {
			document.cookie =
				cookie + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		});
	}

	location.reload();
};

export default passwordLogout;
